module.exports = __webpack_public_path__ + "img/image34.a03af7a8.jpg";